import React from 'react';

const MarketValueCell = ({ value }) => {
  const marketValue = Number(value);
  const hasMarketValue = value != null && Number.isFinite(marketValue);

  return <td>{hasMarketValue ? Math.round(marketValue) : String.fromCharCode(8212)}</td>;
};

export default MarketValueCell;
